// Import Utils
import { shuffleArray } from '../shuffleArray';

const getHotelRanks = (filteredHotelResults) => {
	/** RANKS:
	 * 1 = in guide, paid and not shortlisted
	 * 2 = shortlisted and paid
	 * 3 = in guide, not paid, not shortlisted
	 * 4 = shortlisted not paid
	 * 5 = everything else is the lowest score
	 * TODO: does rank 5 need to change to be 'extended' only?
	 */
	let rankOne = [],
		rankTwo = [],
		rankThree = [],
		rankFour = [],
		rankFive = [];
	// -> First Calculate Rank of hotels
	filteredHotelResults.forEach((hotel) => {
		// For each hotel calculate rank & place in appropriate array
		const { paid, inGuide, shortlist, extended } = hotel.displayOptions;
		if (inGuide && paid && !shortlist) {
			rankOne.push(hotel);
		} else if (paid && shortlist) {
			rankTwo.push(hotel);
		} else if (inGuide && !paid && !shortlist) {
			rankThree.push(hotel);
		} else if (!paid && shortlist) {
			rankFour.push(hotel);
		} else if(extended) {
			rankFive.push(hotel);
		}
	});

	// -> These hotel results can be used for all blocks
	// If there are at least 10 results from rank 1 - 4 then we don't need to add extended
	let ranksLength = (rankOne.length + rankTwo.length + rankThree.length + rankFour.length)
	let hotelResults = ranksLength <= 10
	? [rankOne, rankTwo, rankThree, rankFour, rankFive]
	: [rankOne, rankTwo, rankThree, rankFour];

	// -> For each rank array - shuffle results so it's 'random' order
	hotelResults.forEach((result) => (result = shuffleArray(result)));

	// ? TESTING SHUUFLE!
	// let array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	// array = shuffleArray(array)

	return hotelResults;
};

export { getHotelRanks };
